import { render } from "./NooDleboxt.vue?vue&type=template&id=33d2862f"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/NooDleboxt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33d2862f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33d2862f', __exports__)) {
    api.reload('33d2862f', __exports__)
  }
  
  module.hot.accept("./NooDleboxt.vue?vue&type=template&id=33d2862f", () => {
    api.rerender('33d2862f', render)
  })

}


export default __exports__